todays-deliveries
  .modal(id="save-all-delivery-records-warning" role="dialog" tabindex="-1") 
    .modal-dialog(role="document")
      .modal-content
        .modal-header
          h5.modal-title {locale().modal_title}
          button.close(aria-label="{locale().cancel}" data-dismiss="modal" type="button")
            span(aria-hidden="true")  &times;
        .modal-body
          p {locale().warning_before_save_all}
        .modal-footer
          button.btn.btn-secondary(data-dismiss="modal" type="button") {locale().cancel}
          button.btn.btn-primary(data-dismiss="modal" type="button" onClick="{onClickSave}") {locale().save_do}
  form#delivery-task(action="/delivery_records")
    inputs-hidden(tag-scope="{this.tagScope}.inputs.start")
    section.app-table
      header.app-table-header
        .row
          .col-12
            forms-tasks-deliveries-search(tag-scope="forms_tasks_deliveries_search")
        .row
          .col-12.col-md-6
            todays-deliveries-date-ui(tag-scope="{this.tagScope}")
          .col-12.col-md-6.text-right.control(if="{opts.task_ids.length > 0}")
            todays-deliveries-save-btn(label="{this.locale().save}" data-toggle="modal" data-target="#save-all-delivery-records-warning")
            todays-deliveries-labels-btn(if="{opts.records_exist}" label="{this.locale().labels}" onClick="{onClickLabels}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().attn_labels}")
            todays-deliveries-letters-btn(if="{opts.records_exist}" label="{this.locale().letters}" onClick="{onClickLetter}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().attn_letters}")
            todays-deliveries-download-btn(if="{opts.records_exist}" label="{this.locale().download_for_yamato}" onClick="{onClickDownloadForSagawa}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().attn_csv}")
            .todays-deliveries-labels-btn(if="{!opts.records_exist}")
              span.btn-download.btn.btn-success.grayout.btn-sm(data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().before_save}")
                i.feather.icon-download
                | { this.locale().labels }
            .todays-deliveries-letters-btn(if="{!opts.records_exist}")
              span.btn-download.btn.btn-success.grayout.btn-sm(data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().before_save}")
                i.feather.icon-download
                | { this.locale().letters }
            .todays-deliveries-download-btn(if="{!opts.records_exist}")
              span.btn-download.btn.btn-success.grayout.btn-sm(data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().before_save}")
                i.feather.icon-download
                | { this.locale().download_for_yamato }
      .app-table-body
        .alert.alert-warning(if="{hasDifferentTodaysValue()}")
          | { this.locale().warn_different_num }
        .ctrl.text-right
          inputs-without-label-checkall(scope="{document}" query='input[class="ck_tasks"]')
        todays-deliveries-task(each="{id in opts.task_ids}" tag-scope="task_{id}" checkbox_class="ck_tasks")
      footer.app-table-header
        .row
          .col-12.col-md-6
            todays-deliveries-date-ui(tag-scope="{this.tagScope}")
          .col-12.col-md-6.text-right.control(if="{opts.task_ids.length > 0}")
            todays-deliveries-save-btn(label="{this.locale().save}" data-toggle="modal" data-target="#save-all-delivery-records-warning")
            todays-deliveries-letters-btn(if="{opts.records_exist}" label="{this.locale().letters}" onClick="{onClickLetter}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().attn_letters}")
            todays-deliveries-download-btn(if="{opts.records_exist}" label="{this.locale().download_for_yamato}" onClick="{onClickDownloadForSagawa}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().attn_csv}")
            .todays-deliveries-letters-btn(if="{!opts.records_exist}")
              span.btn-download.btn.btn-success.grayout.btn-sm(data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().before_save}")
                i.feather.icon-download
                | { this.locale().letters }
            .todays-deliveries-download-btn(if="{!opts.records_exist}")
              span.btn-download.btn.btn-success.grayout.btn-sm(data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().before_save}")
                i.feather.icon-download
                | { this.locale().download_for_yamato }
  script(type="typescript").
    this.mixin('todays.deliveries');
  style(scoped).
    .app-table-body .row {
      padding-top: 18px;
    }
    .grayout {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
      cursor: not-allowed !important;
    }
    todays-deliveries-save-btn,
    todays-deliveries-labels-btn,
    todays-deliveries-download-btn,
    todays-deliveries-letters-btn,
    .todays-deliveries-download-btn,
    .todays-deliveries-labels-btn,
    .todays-deliveries-letters-btn {
      display: inline-block;
      margin-left: 2px;
      margin-top: 4px;
    }
    @media print {
      inputs-without-label-checkall,
      inputs-search-submit,
      .prev-day,
      .next-day,
      header .control,
      footer .control{
        display: none;
      }
    }
